import Swup from 'swup';
// import SwupScriptsPlugin from '@swup/scripts-plugin/dist/SwupScriptsPlugin.min';
// import Splide from '@splidejs/splide';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import intersect from '@alpinejs/intersect';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-cards';
import 'swiper/css/free-mode';

// Import Alpine components
import './components/accordion.js';
import './components/rule.js';
import './components/spacer.js';
import './components/swiper.js';
import './components/cursorFollower.js';
import './components/homeReel.js';

window.isMobile = window.matchMedia('only screen and (max-width: 760px)').matches;


const options = {
  plugins: [
    // new SwupScriptsPlugin()
  ]
};

// Register Alpine plugins before starting
Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(intersect);

// Make Alpine available globally
window.Alpine = Alpine;

const swup = new Swup(options);

// Events
swup.hooks.on('content:replace', init);

document.addEventListener('DOMContentLoaded', () => {
  l('ready');
  // Start Alpine.js
  Alpine.start();
  // checkCookie();
  init();
});

// Functions 

// Better console.log – only for local .test urls
function l(m) {
  if (window.location.hostname.split('.').at(-1) == 'test') {
    console.log(m);
  }
}

function init() {
  l('👍');
  // Initialize functions
  // isMobile = window.matchMedia('only screen and (max-width: 782px)').matches; 
  // console.log()
  // window.addEventListener('resize', () => { isMobile = window.innerWidth < 768; });
}